import styled from '@emotion/styled';

import Button from '../../../../../../../../components/button';
import theme from '../../../../../../../../theme';

export const Wrapper = styled('div')`
  .ant-list-item-meta-title {
    font-weight: bold;
    color: ${theme.colorsBlack};
  }
  .ant-list-item-meta-description {
    color: ${theme.colorsBlack};
  }
  .ant-list-item {
    border-bottom: 0 !important;
  }
`;

export const FileLink = styled(Button)`
  &.ant-btn {
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    color: ${theme.colorsSecondaryBlue};
    text-decoration: underline;

    &:hover {
      font-weight: bold;
    }
  }
`;
